/* tslint:disable */
/* eslint-disable */
/**
 * central-database-service
 * REST API for Central Database
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * Request interface for adding business units to an existing customer
 */
export interface AddBusinessUnitsRequest {
    /**
     * Array of business unit information to add to the customer
     */
    'business_units': Array<BusinessUnitInfo>;
}
export interface BusinessUnitGstInfo {
    'gst_in'?: string;
    'gst_session_expires_at'?: string;
    'gst_session_validity'?: number;
    'gst_username'?: string;
}
/**
 * Interface for business unit information
 */
export interface BusinessUnitInfo {
    /**
     * GSTIN number (optional)
     */
    'gst_in'?: string;
    /**
     * GST username for this GSTIN (optional)
     */
    'gst_username'?: string;
    /**
     * Business unit name
     */
    'name': string;
    /**
     * Business unit location (optional)
     */
    'location'?: string;
    /**
     * GST session expiry timestamp
     */
    'gst_session_expires_at'?: string;
    /**
     * GST session validity
     */
    'gst_session_validity'?: number;
}
/**
 * Enum representing the counter party type of a Party V2.  Identifies which side of a ledger relationship the party occupies. NULL when the party is a payment gateway or bank (it has no counter-party relationship in that sense). Required for parties of `party_type = \'business\'`.
 */

export const CounterPartyType = {
    Customer: 'customer',
    Vendor: 'vendor',
} as const;

export type CounterPartyType = typeof CounterPartyType[keyof typeof CounterPartyType];


/**
 * Interface for creating a new customer Takes name and business unit information as input
 */
export interface CreateCustomerInterface {
    /**
     * Name of the customer/company
     */
    'name': string;
    /**
     * Array of business unit information for the customer
     */
    'business_units': Array<BusinessUnitInfo>;
    /**
     * List of permissions to enable
     */
    'permissions'?: Array<PermissionKey>;
    /**
     * email of the customer
     */
    'email'?: string;
    /**
     * phone of the customer
     */
    'phone'?: string;
}
/**
 * Interface representing a request to create a Party V2
 */
export interface CreatePartyV2Request {
    'name': string;
    'email'?: string;
    'counter_party_type': CounterPartyType | null;
    'party_type': PartyType;
    'gstin'?: string;
    'pan'?: string;
    'address'?: string;
    'contact_no'?: string;
    'short_name'?: string;
}


/**
 * Interface representing a request to create a Point of Contact V2
 */
export interface CreatePocV2Request {
    'party_id': string;
    'name': string;
    'email': string;
    'contact_no'?: string;
}
/**
 * Shape of the config JSONB column on customers. Only \'quotas\' is used now; other keys may be added in future.
 */
export interface CustomerConfig {
    [key: string]: any;

    'quotas'?: CustomerQuotas;
}
/**
 * Per-recon-type quota limits stored in config.quotas. A null value for a key means unlimited for that type.
 */
export interface CustomerQuotas {
    [key: string]: number | any;

    'ledger_recon'?: number | null;
    'bank_recon'?: number | null;
    'pg_recon'?: number | null;
}
/**
 * Plan tier for a customer.  free       — subject to per-recon-type monthly quotas defined in config.quotas enterprise — unlimited access; config.quotas keys are null or absent  Set by admin only via POST /customers/update-plan. All existing customers default to enterprise on migration.
 */

export const CustomerType = {
    Free: 'free',
    Enterprise: 'enterprise',
} as const;

export type CustomerType = typeof CustomerType[keyof typeof CustomerType];


export interface DecodedUserInfo {
    'customer_id': string;
    'customer_name': string;
    'email': string;
    'phone': string;
    'first_name': string;
    'last_name': string;
    'username': string;
    'permission': Permissions;
    'permission_scope': PermissionScope;
    'sub'?: string;
    'business_units': Array<BusinessUnitGstInfo>;
    'admin': boolean;
    'customer_type': CustomerType;
    'config': CustomerConfig;
}


export interface ICurrentUserResponse {
    'success': boolean;
    'data': DecodedUserInfo | null;
    'error'?: string;
}
export interface ICustomer {
    /**
     * postgres id
     */
    'id'?: string;
    /**
     * Name of the customer/company
     */
    'name': string;
    /**
     * Primary GSTIN number of the customer (legacy field)
     */
    'gst_in'?: string;
    /**
     * Business units for the customer
     */
    'businessUnits'?: Array<BusinessUnitInfo>;
    /**
     * Unique customer identifier
     */
    'customer_id'?: string;
    /**
     * Email address of the customer
     */
    'email'?: string;
    /**
     * Phone number of the customer
     */
    'phone'?: string;
    /**
     * GST username for the primary GSTIN (legacy field)
     */
    'gst_username'?: string;
    /**
     * Definition for tag1
     */
    'tag1_def'?: string;
    /**
     * Definition for tag2
     */
    'tag2_def'?: string;
    /**
     * Definition for tag3
     */
    'tag3_def'?: string;
    /**
     * Definition for tag4
     */
    'tag4_def'?: string;
    /**
     * Definition for tag5
     */
    'tag5_def'?: string;
    'permission_scope': PermissionScope;
    /**
     * Partner ID if customer is assigned to a partner
     */
    'partner_id'?: string;
    'permissions': Permissions;
}


/**
 * Response interface for customer operations
 */
export interface ICustomerResponse {
    'success': boolean;
    'data': ICustomer | null;
    'error'?: string;
}
/**
 * Response interface for multiple customers
 */
export interface ICustomersResponse {
    'success': boolean;
    'data': Array<ICustomer>;
    'total': number;
    'page': number;
    'total_pages': number;
    'error'?: string;
}
export interface IHealthData {
    'status': string;
    'timestamp': string;
}
export interface IHealthResponse {
    'success': boolean;
    'data': IHealthData;
    'error'?: string;
}
/**
 * Interface for a response with a single Party V2
 */
export interface IPartyV2Response {
    'success': boolean;
    'data': PartyV2 | null;
    'error': string | null;
}
/**
 * Interface for a response with multiple Parties V2
 */
export interface IPartyV2Responses {
    'success': boolean;
    'data': Array<PartyV2>;
    'total': number;
    'page': number;
    'total_pages': number;
    'error': string | null;
}
export interface IUser {
    'id'?: string;
    'customer_id'?: string;
    'first_name': string;
    'last_name': string;
    'email': string;
    'phone': string;
    'cognito_id'?: string;
}
export interface IUserRequest {
    'first_name': string;
    'last_name': string;
    'email': string;
    'phone': string;
    'customer_id'?: string;
    'cognito_id'?: string;
}
export interface IUserResponse {
    'success': boolean;
    'data': IUser;
    'error'?: string;
}
export interface IUsersResponse {
    'success': boolean;
    'data': Array<IUser>;
    'total': number;
    'page': number;
    'total_pages': number;
    'error'?: string;
}
/**
 * Enum representing the business classification of a Party V2.  Mirrors the GRS `recon_type`:   - `PG`       ↔ pg_recon   - `BANK`     ↔ bank_recon   - `BUSINESS` ↔ ledger_recon  Combined with `counter_party_type`, this forms part of the party\'s identity key — see `UQ_parties_v2_customer_id_name_party_type` for the DB-level enforcement.
 */

export const PartyType = {
    Pg: 'pg',
    Bank: 'bank',
    Business: 'business',
} as const;

export type PartyType = typeof PartyType[keyof typeof PartyType];


/**
 * Interface representing a Party V2
 */
export interface PartyV2 {
    'id'?: string;
    'customer_id': string;
    'name': string;
    'email'?: string;
    'counter_party_type': CounterPartyType | null;
    'party_type': PartyType;
    'gstin'?: string;
    'pan'?: string;
    'address'?: string;
    'contact_no'?: string;
    'short_name'?: string;
    'is_deleted'?: boolean;
    'created_at'?: string;
    'updated_at'?: string;
}


/**
 * Enum representing permission keys
 */

export const PermissionKey = {
    LedgerReconciliation: 'ledger_reconciliation',
    TdsReconciliation: 'tds_reconciliation',
    Normalization: 'normalization',
    AiAssistant: 'ai_assistant',
    PaymentsReconciliation: 'payments_reconciliation',
    Reminders: 'reminders',
    AiAnalyst: 'ai_analyst',
    PgRecon: 'pg_recon',
    BankRecon: 'bank_recon',
    Debug: 'debug',
    LedgerRecon: 'ledger_recon',
    BalanceConfirmation: 'balance_confirmation',
    AdminPortal: 'admin_portal',
    MasterData: 'master_data',
} as const;

export type PermissionKey = typeof PermissionKey[keyof typeof PermissionKey];


/**
 * Enum for permission scope settings
 */

export const PermissionScope = {
    Customer: 'customer',
    User: 'user',
} as const;

export type PermissionScope = typeof PermissionScope[keyof typeof PermissionScope];


/**
 * Interface representing permissions object
 */
export interface Permissions {
    'ledger_reconciliation'?: boolean;
    'tds_reconciliation'?: boolean;
    'normalization'?: boolean;
    'ai_assistant'?: boolean;
    'payments_reconciliation'?: boolean;
    'reminders'?: boolean;
    'ai_analyst'?: boolean;
    'pg_recon'?: boolean;
    'bank_recon'?: boolean;
    'debug'?: boolean;
    'ledger_recon'?: boolean;
    'balance_confirmation'?: boolean;
    'admin_portal'?: boolean;
    'master_data'?: boolean;
}
/**
 * Interface representing a response for permission operations
 */
export interface PermissionsResponse {
    'success': boolean;
    'data': Permissions;
    'error'?: string;
}
/**
 * Interface representing a Point of Contact V2
 */
export interface PocV2 {
    'id': string;
    'party_id': string;
    'name': string;
    'email': string;
    'contact_no'?: string;
    'is_deleted'?: boolean;
    'created_at'?: string;
    'updated_at'?: string;
}
/**
 * Interface for a response with a single Point of Contact V2
 */
export interface PocV2Response {
    'success': boolean;
    'data': PocV2 | null;
    'error': string | null;
}
/**
 * Interface for a response with multiple Points of Contact V2
 */
export interface PocsV2Response {
    'success': boolean;
    'data': Array<PocV2>;
    'total': number;
    'page': number;
    'total_pages': number;
    'error': string | null;
}
export interface UpdateCustomerPermissionRequest {
    'permissions': Permissions;
}
/**
 * Request interface for updating customer tag definitions All fields are optional since customers can update any subset of tags
 */
export interface UpdateCustomerTagDefinitionsRequest {
    /**
     * Definition for tag1 - what tag1 represents (e.g., \"Department\")
     */
    'tag1_def'?: string;
    /**
     * Definition for tag2 - what tag2 represents (e.g., \"Project\")
     */
    'tag2_def'?: string;
    /**
     * Definition for tag3 - what tag3 represents (e.g., \"Location\")
     */
    'tag3_def'?: string;
    /**
     * Definition for tag4 - what tag4 represents (e.g., \"Category\")
     */
    'tag4_def'?: string;
    /**
     * Definition for tag5 - what tag5 represents (e.g., \"Priority\")
     */
    'tag5_def'?: string;
}
/**
 * Request interface for updating GST session
 */
export interface UpdateGstSessionRequest {
    /**
     * GSTIN number to update
     */
    'gst_in': string;
}
/**
 * Request interface for updating GST session validity
 */
export interface UpdateGstSessionValidityRequest {
    /**
     * GSTIN number to update
     */
    'gst_in': string;
    /**
     * GST session validity
     */
    'gst_session_validity': number;
}
/**
 * Request interface for updating business unit GST username
 */
export interface UpdateGstUsernameRequest {
    /**
     * GSTIN number to update
     */
    'gst_in': string;
    /**
     * New GST username for the specified GSTIN
     */
    'gst_username': string;
}
/**
 * Interface representing a request to update a Party V2.  `party_type` is intentionally NOT updatable — switching a party between Business / PG / Bank changes its identity (and would invalidate references from GRS `entities.remote_entity_id`). Change = soft-delete + recreate.
 */
export interface UpdatePartyV2Request {
    'name'?: string;
    'email'?: string;
    'counter_party_type'?: CounterPartyType | null;
    'gstin'?: string;
    'pan'?: string;
    'address'?: string;
    'contact_no'?: string;
    'short_name'?: string;
}


/**
 * Request body for the admin-only update-plan endpoint.  Sets customer_type and config atomically in one call.  config.quotas shape:   { ledger_recon: N, bank_recon: N, pg_recon: N }   null value for a key = unlimited for that recon type.   Enterprise customers should pass config = {} (all unlimited).  Auth: isAdmin = true required — enforced at controller layer. Regular users calling this endpoint receive 403.
 */
export interface UpdatePlanRequest {
    'customer_type': CustomerType;
    'config': CustomerConfig;
    /**
     * The customer_id of the customer whose plan is being updated
     */
    'target_customer_id': string;
}


/**
 * Interface representing a request to update a Point of Contact V2
 */
export interface UpdatePocV2Request {
    'name'?: string;
    'email'?: string;
    'contact_no'?: string;
}
/**
 * Permission data to update
 */
export interface UpdateUserPermissionsRequest {
    'permissions': Permissions;
}

/**
 * CustomerApi - axios parameter creator
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add business units to an existing customer
         * @param {AddBusinessUnitsRequest} addBusinessUnitsRequest Array of business unit information to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBusinessUnitsToCustomer: async (addBusinessUnitsRequest: AddBusinessUnitsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addBusinessUnitsRequest' is not null or undefined
            assertParamExists('addBusinessUnitsToCustomer', 'addBusinessUnitsRequest', addBusinessUnitsRequest)
            const localVarPath = `/api/v1/customers/add-business-units`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addBusinessUnitsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new customer
         * @param {CreateCustomerInterface} createCustomerInterface Customer creation data (name, primary GSTIN, and additional GSTINs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer: async (createCustomerInterface: CreateCustomerInterface, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCustomerInterface' is not null or undefined
            assertParamExists('createCustomer', 'createCustomerInterface', createCustomerInterface)
            const localVarPath = `/api/v1/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomerInterface, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all customers with pagination
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomers: async (page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails: async (search?: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customers/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagDefinitions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/customers/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create customer permissions using JSONB system
         * @param {UpdateCustomerPermissionRequest} updateCustomerPermissionRequest Permission data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerPermissions: async (updateCustomerPermissionRequest: UpdateCustomerPermissionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCustomerPermissionRequest' is not null or undefined
            assertParamExists('updateCustomerPermissions', 'updateCustomerPermissionRequest', updateCustomerPermissionRequest)
            const localVarPath = `/api/v1/customers/update-permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerPermissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGstSessionRequest} updateGstSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGstSession: async (updateGstSessionRequest: UpdateGstSessionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateGstSessionRequest' is not null or undefined
            assertParamExists('updateGstSession', 'updateGstSessionRequest', updateGstSessionRequest)
            const localVarPath = `/api/v1/customers/update-gst-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGstSessionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGstSessionValidityRequest} updateGstSessionValidityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGstSessionValidity: async (updateGstSessionValidityRequest: UpdateGstSessionValidityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateGstSessionValidityRequest' is not null or undefined
            assertParamExists('updateGstSessionValidity', 'updateGstSessionValidityRequest', updateGstSessionValidityRequest)
            const localVarPath = `/api/v1/customers/update-gst-session-validity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGstSessionValidityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update GST username for a customer
         * @param {UpdateGstUsernameRequest} updateGstUsernameRequest GST username data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGstUsername: async (updateGstUsernameRequest: UpdateGstUsernameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateGstUsernameRequest' is not null or undefined
            assertParamExists('updateGstUsername', 'updateGstUsernameRequest', updateGstUsernameRequest)
            const localVarPath = `/api/v1/customers/update-gst-username`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGstUsernameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a customer\'s plan tier and recon quota.    Admin-only. Sets customer_type and recon_quota atomically in one call.  Pass recon_quota = null for enterprise (unlimited).    Returns 403 if the caller is not an admin.  Returns 404 if the target customer is not found.
         * @param {UpdatePlanRequest} updatePlanRequest UpdatePlanRequest — customer_type, recon_quota, target_customer_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan: async (updatePlanRequest: UpdatePlanRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePlanRequest' is not null or undefined
            assertParamExists('updatePlan', 'updatePlanRequest', updatePlanRequest)
            const localVarPath = `/api/v1/customers/update-plan`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateCustomerTagDefinitionsRequest} updateCustomerTagDefinitionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagDefinitions: async (updateCustomerTagDefinitionsRequest: UpdateCustomerTagDefinitionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateCustomerTagDefinitionsRequest' is not null or undefined
            assertParamExists('updateTagDefinitions', 'updateCustomerTagDefinitionsRequest', updateCustomerTagDefinitionsRequest)
            const localVarPath = `/api/v1/customers/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomerTagDefinitionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * Add business units to an existing customer
         * @param {AddBusinessUnitsRequest} addBusinessUnitsRequest Array of business unit information to add
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addBusinessUnitsToCustomer(addBusinessUnitsRequest: AddBusinessUnitsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addBusinessUnitsToCustomer(addBusinessUnitsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.addBusinessUnitsToCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new customer
         * @param {CreateCustomerInterface} createCustomerInterface Customer creation data (name, primary GSTIN, and additional GSTINs)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomer(createCustomerInterface: CreateCustomerInterface, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomer(createCustomerInterface, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createCustomer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all customers with pagination
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of items per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllCustomers(page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllCustomers(page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getAllCustomers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomerDetails(search?: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomerDetails(search, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getCustomerDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTagDefinitions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: string; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTagDefinitions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getTagDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create customer permissions using JSONB system
         * @param {UpdateCustomerPermissionRequest} updateCustomerPermissionRequest Permission data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomerPermissions(updateCustomerPermissionRequest: UpdateCustomerPermissionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomerPermissions(updateCustomerPermissionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateCustomerPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateGstSessionRequest} updateGstSessionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGstSession(updateGstSessionRequest: UpdateGstSessionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGstSession(updateGstSessionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateGstSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateGstSessionValidityRequest} updateGstSessionValidityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGstSessionValidity(updateGstSessionValidityRequest: UpdateGstSessionValidityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGstSessionValidity(updateGstSessionValidityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateGstSessionValidity']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update GST username for a customer
         * @param {UpdateGstUsernameRequest} updateGstUsernameRequest GST username data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateGstUsername(updateGstUsernameRequest: UpdateGstUsernameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateGstUsername(updateGstUsernameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateGstUsername']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a customer\'s plan tier and recon quota.    Admin-only. Sets customer_type and recon_quota atomically in one call.  Pass recon_quota = null for enterprise (unlimited).    Returns 403 if the caller is not an admin.  Returns 404 if the target customer is not found.
         * @param {UpdatePlanRequest} updatePlanRequest UpdatePlanRequest — customer_type, recon_quota, target_customer_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePlan(updatePlanRequest: UpdatePlanRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePlan(updatePlanRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updatePlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateCustomerTagDefinitionsRequest} updateCustomerTagDefinitionsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTagDefinitions(updateCustomerTagDefinitionsRequest: UpdateCustomerTagDefinitionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICustomerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTagDefinitions(updateCustomerTagDefinitionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateTagDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * Add business units to an existing customer
         * @param {CustomerApiAddBusinessUnitsToCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addBusinessUnitsToCustomer(requestParameters: CustomerApiAddBusinessUnitsToCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.addBusinessUnitsToCustomer(requestParameters.addBusinessUnitsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new customer
         * @param {CustomerApiCreateCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomer(requestParameters: CustomerApiCreateCustomerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.createCustomer(requestParameters.createCustomerInterface, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all customers with pagination
         * @param {CustomerApiGetAllCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllCustomers(requestParameters: CustomerApiGetAllCustomersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ICustomersResponse> {
            return localVarFp.getAllCustomers(requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomerApiGetCustomerDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerDetails(requestParameters: CustomerApiGetCustomerDetailsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ICustomersResponse> {
            return localVarFp.getCustomerDetails(requestParameters.search, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTagDefinitions(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: string; }> {
            return localVarFp.getTagDefinitions(options).then((request) => request(axios, basePath));
        },
        /**
         * Create customer permissions using JSONB system
         * @param {CustomerApiUpdateCustomerPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomerPermissions(requestParameters: CustomerApiUpdateCustomerPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PermissionsResponse> {
            return localVarFp.updateCustomerPermissions(requestParameters.updateCustomerPermissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomerApiUpdateGstSessionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGstSession(requestParameters: CustomerApiUpdateGstSessionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.updateGstSession(requestParameters.updateGstSessionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomerApiUpdateGstSessionValidityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGstSessionValidity(requestParameters: CustomerApiUpdateGstSessionValidityRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.updateGstSessionValidity(requestParameters.updateGstSessionValidityRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update GST username for a customer
         * @param {CustomerApiUpdateGstUsernameRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGstUsername(requestParameters: CustomerApiUpdateGstUsernameRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.updateGstUsername(requestParameters.updateGstUsernameRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a customer\'s plan tier and recon quota.    Admin-only. Sets customer_type and recon_quota atomically in one call.  Pass recon_quota = null for enterprise (unlimited).    Returns 403 if the caller is not an admin.  Returns 404 if the target customer is not found.
         * @param {CustomerApiUpdatePlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePlan(requestParameters: CustomerApiUpdatePlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.updatePlan(requestParameters.updatePlanRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CustomerApiUpdateTagDefinitionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTagDefinitions(requestParameters: CustomerApiUpdateTagDefinitionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ICustomerResponse> {
            return localVarFp.updateTagDefinitions(requestParameters.updateCustomerTagDefinitionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for addBusinessUnitsToCustomer operation in CustomerApi.
 */
export interface CustomerApiAddBusinessUnitsToCustomerRequest {
    /**
     * Array of business unit information to add
     */
    readonly addBusinessUnitsRequest: AddBusinessUnitsRequest
}

/**
 * Request parameters for createCustomer operation in CustomerApi.
 */
export interface CustomerApiCreateCustomerRequest {
    /**
     * Customer creation data (name, primary GSTIN, and additional GSTINs)
     */
    readonly createCustomerInterface: CreateCustomerInterface
}

/**
 * Request parameters for getAllCustomers operation in CustomerApi.
 */
export interface CustomerApiGetAllCustomersRequest {
    /**
     * Page number for pagination
     */
    readonly page?: number

    /**
     * Number of items per page
     */
    readonly limit?: number
}

/**
 * Request parameters for getCustomerDetails operation in CustomerApi.
 */
export interface CustomerApiGetCustomerDetailsRequest {
    readonly search?: string

    readonly page?: number

    readonly limit?: number
}

/**
 * Request parameters for updateCustomerPermissions operation in CustomerApi.
 */
export interface CustomerApiUpdateCustomerPermissionsRequest {
    /**
     * Permission data to create
     */
    readonly updateCustomerPermissionRequest: UpdateCustomerPermissionRequest
}

/**
 * Request parameters for updateGstSession operation in CustomerApi.
 */
export interface CustomerApiUpdateGstSessionRequest {
    readonly updateGstSessionRequest: UpdateGstSessionRequest
}

/**
 * Request parameters for updateGstSessionValidity operation in CustomerApi.
 */
export interface CustomerApiUpdateGstSessionValidityRequest {
    readonly updateGstSessionValidityRequest: UpdateGstSessionValidityRequest
}

/**
 * Request parameters for updateGstUsername operation in CustomerApi.
 */
export interface CustomerApiUpdateGstUsernameRequest {
    /**
     * GST username data
     */
    readonly updateGstUsernameRequest: UpdateGstUsernameRequest
}

/**
 * Request parameters for updatePlan operation in CustomerApi.
 */
export interface CustomerApiUpdatePlanRequest {
    /**
     * UpdatePlanRequest — customer_type, recon_quota, target_customer_id
     */
    readonly updatePlanRequest: UpdatePlanRequest
}

/**
 * Request parameters for updateTagDefinitions operation in CustomerApi.
 */
export interface CustomerApiUpdateTagDefinitionsRequest {
    readonly updateCustomerTagDefinitionsRequest: UpdateCustomerTagDefinitionsRequest
}

/**
 * CustomerApi - object-oriented interface
 */
export class CustomerApi extends BaseAPI {
    /**
     * Add business units to an existing customer
     * @param {CustomerApiAddBusinessUnitsToCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addBusinessUnitsToCustomer(requestParameters: CustomerApiAddBusinessUnitsToCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).addBusinessUnitsToCustomer(requestParameters.addBusinessUnitsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new customer
     * @param {CustomerApiCreateCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCustomer(requestParameters: CustomerApiCreateCustomerRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createCustomer(requestParameters.createCustomerInterface, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all customers with pagination
     * @param {CustomerApiGetAllCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllCustomers(requestParameters: CustomerApiGetAllCustomersRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getAllCustomers(requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiGetCustomerDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCustomerDetails(requestParameters: CustomerApiGetCustomerDetailsRequest = {}, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getCustomerDetails(requestParameters.search, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTagDefinitions(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getTagDefinitions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create customer permissions using JSONB system
     * @param {CustomerApiUpdateCustomerPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateCustomerPermissions(requestParameters: CustomerApiUpdateCustomerPermissionsRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateCustomerPermissions(requestParameters.updateCustomerPermissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiUpdateGstSessionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGstSession(requestParameters: CustomerApiUpdateGstSessionRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateGstSession(requestParameters.updateGstSessionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiUpdateGstSessionValidityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGstSessionValidity(requestParameters: CustomerApiUpdateGstSessionValidityRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateGstSessionValidity(requestParameters.updateGstSessionValidityRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update GST username for a customer
     * @param {CustomerApiUpdateGstUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateGstUsername(requestParameters: CustomerApiUpdateGstUsernameRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateGstUsername(requestParameters.updateGstUsernameRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a customer\'s plan tier and recon quota.    Admin-only. Sets customer_type and recon_quota atomically in one call.  Pass recon_quota = null for enterprise (unlimited).    Returns 403 if the caller is not an admin.  Returns 404 if the target customer is not found.
     * @param {CustomerApiUpdatePlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePlan(requestParameters: CustomerApiUpdatePlanRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updatePlan(requestParameters.updatePlanRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CustomerApiUpdateTagDefinitionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTagDefinitions(requestParameters: CustomerApiUpdateTagDefinitionsRequest, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateTagDefinitions(requestParameters.updateCustomerTagDefinitionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHealth(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IHealthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHealth(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.getHealth']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHealth(options?: RawAxiosRequestConfig): AxiosPromise<IHealthResponse> {
            return localVarFp.getHealth(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 */
export class HealthApi extends BaseAPI {
    /**
     * Health check endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getHealth(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).getHealth(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartiesV2Api - axios parameter creator
 */
export const PartiesV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new party.  `party_type` is mandatory after Phase 1 of the party unification — every party must declare its business class (`pg`, `bank`, `business`). `counter_party_type` is mandatory only for `business`; the service layer rejects mismatches.
         * @param {CreatePartyV2Request} createPartyV2Request Party creation data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartyV2: async (createPartyV2Request: CreatePartyV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPartyV2Request' is not null or undefined
            assertParamExists('createPartyV2', 'createPartyV2Request', createPartyV2Request)
            const localVarPath = `/api/v2/parties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartyV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a party (set is_deleted to true)
         * @param {string} id Party ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartyV2: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePartyV2', 'id', id)
            const localVarPath = `/api/v2/parties/{id}/delete-party`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List parties with optional filtering, search, batch lookup, and pagination.  Filter semantics relevant to the GRS unification flow:   - `ids` (repeated query param) — batch lookup. GRS uses this to enrich     a list of `entities` rows in one call instead of N+1.   - `party_type` — required for the GRS create / search flow; absent for     legacy callers.   - `counter_party_type` — multi-value array (`?counter_party_type=customer&counter_party_type=vendor`).     When `party_type=pg|bank` and no `counter_party_type` is provided, the     service applies an `IS NULL` filter (PG/Bank parties have no counter-party).
         * @param {string} [id] 
         * @param {Array<string>} [ids] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [contactNo] 
         * @param {string} [shortName] 
         * @param {string} [search] 
         * @param {CounterPartyType} [counterPartyType] 
         * @param {PartyType} [partyType] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartiesV2: async (id?: string, ids?: Array<string>, name?: string, email?: string, contactNo?: string, shortName?: string, search?: string, counterPartyType?: CounterPartyType, partyType?: PartyType, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/parties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (contactNo !== undefined) {
                localVarQueryParameter['contact_no'] = contactNo;
            }

            if (shortName !== undefined) {
                localVarQueryParameter['short_name'] = shortName;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (counterPartyType !== undefined) {
                localVarQueryParameter['counter_party_type'] = counterPartyType;
            }

            if (partyType !== undefined) {
                localVarQueryParameter['party_type'] = partyType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get party by ID
         * @param {string} id Party ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartyByIdV2: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartyByIdV2', 'id', id)
            const localVarPath = `/api/v2/parties/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing party
         * @param {string} id Party ID
         * @param {UpdatePartyV2Request} updatePartyV2Request Party data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyV2: async (id: string, updatePartyV2Request: UpdatePartyV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePartyV2', 'id', id)
            // verify required parameter 'updatePartyV2Request' is not null or undefined
            assertParamExists('updatePartyV2', 'updatePartyV2Request', updatePartyV2Request)
            const localVarPath = `/api/v2/parties/{id}/update-details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartyV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartiesV2Api - functional programming interface
 */
export const PartiesV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartiesV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new party.  `party_type` is mandatory after Phase 1 of the party unification — every party must declare its business class (`pg`, `bank`, `business`). `counter_party_type` is mandatory only for `business`; the service layer rejects mismatches.
         * @param {CreatePartyV2Request} createPartyV2Request Party creation data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartyV2(createPartyV2Request: CreatePartyV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPartyV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartyV2(createPartyV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesV2Api.createPartyV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete a party (set is_deleted to true)
         * @param {string} id Party ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePartyV2(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPartyV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePartyV2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesV2Api.deletePartyV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List parties with optional filtering, search, batch lookup, and pagination.  Filter semantics relevant to the GRS unification flow:   - `ids` (repeated query param) — batch lookup. GRS uses this to enrich     a list of `entities` rows in one call instead of N+1.   - `party_type` — required for the GRS create / search flow; absent for     legacy callers.   - `counter_party_type` — multi-value array (`?counter_party_type=customer&counter_party_type=vendor`).     When `party_type=pg|bank` and no `counter_party_type` is provided, the     service applies an `IS NULL` filter (PG/Bank parties have no counter-party).
         * @param {string} [id] 
         * @param {Array<string>} [ids] 
         * @param {string} [name] 
         * @param {string} [email] 
         * @param {string} [contactNo] 
         * @param {string} [shortName] 
         * @param {string} [search] 
         * @param {CounterPartyType} [counterPartyType] 
         * @param {PartyType} [partyType] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartiesV2(id?: string, ids?: Array<string>, name?: string, email?: string, contactNo?: string, shortName?: string, search?: string, counterPartyType?: CounterPartyType, partyType?: PartyType, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPartyV2Responses>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartiesV2(id, ids, name, email, contactNo, shortName, search, counterPartyType, partyType, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesV2Api.getPartiesV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get party by ID
         * @param {string} id Party ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartyByIdV2(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPartyV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartyByIdV2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesV2Api.getPartyByIdV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing party
         * @param {string} id Party ID
         * @param {UpdatePartyV2Request} updatePartyV2Request Party data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePartyV2(id: string, updatePartyV2Request: UpdatePartyV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IPartyV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePartyV2(id, updatePartyV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartiesV2Api.updatePartyV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartiesV2Api - factory interface
 */
export const PartiesV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartiesV2ApiFp(configuration)
    return {
        /**
         * Create a new party.  `party_type` is mandatory after Phase 1 of the party unification — every party must declare its business class (`pg`, `bank`, `business`). `counter_party_type` is mandatory only for `business`; the service layer rejects mismatches.
         * @param {PartiesV2ApiCreatePartyV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartyV2(requestParameters: PartiesV2ApiCreatePartyV2Request, options?: RawAxiosRequestConfig): AxiosPromise<IPartyV2Response> {
            return localVarFp.createPartyV2(requestParameters.createPartyV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a party (set is_deleted to true)
         * @param {PartiesV2ApiDeletePartyV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePartyV2(requestParameters: PartiesV2ApiDeletePartyV2Request, options?: RawAxiosRequestConfig): AxiosPromise<IPartyV2Response> {
            return localVarFp.deletePartyV2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List parties with optional filtering, search, batch lookup, and pagination.  Filter semantics relevant to the GRS unification flow:   - `ids` (repeated query param) — batch lookup. GRS uses this to enrich     a list of `entities` rows in one call instead of N+1.   - `party_type` — required for the GRS create / search flow; absent for     legacy callers.   - `counter_party_type` — multi-value array (`?counter_party_type=customer&counter_party_type=vendor`).     When `party_type=pg|bank` and no `counter_party_type` is provided, the     service applies an `IS NULL` filter (PG/Bank parties have no counter-party).
         * @param {PartiesV2ApiGetPartiesV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartiesV2(requestParameters: PartiesV2ApiGetPartiesV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<IPartyV2Responses> {
            return localVarFp.getPartiesV2(requestParameters.id, requestParameters.ids, requestParameters.name, requestParameters.email, requestParameters.contactNo, requestParameters.shortName, requestParameters.search, requestParameters.counterPartyType, requestParameters.partyType, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get party by ID
         * @param {PartiesV2ApiGetPartyByIdV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartyByIdV2(requestParameters: PartiesV2ApiGetPartyByIdV2Request, options?: RawAxiosRequestConfig): AxiosPromise<IPartyV2Response> {
            return localVarFp.getPartyByIdV2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing party
         * @param {PartiesV2ApiUpdatePartyV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartyV2(requestParameters: PartiesV2ApiUpdatePartyV2Request, options?: RawAxiosRequestConfig): AxiosPromise<IPartyV2Response> {
            return localVarFp.updatePartyV2(requestParameters.id, requestParameters.updatePartyV2Request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPartyV2 operation in PartiesV2Api.
 */
export interface PartiesV2ApiCreatePartyV2Request {
    /**
     * Party creation data
     */
    readonly createPartyV2Request: CreatePartyV2Request
}

/**
 * Request parameters for deletePartyV2 operation in PartiesV2Api.
 */
export interface PartiesV2ApiDeletePartyV2Request {
    /**
     * Party ID
     */
    readonly id: string
}

/**
 * Request parameters for getPartiesV2 operation in PartiesV2Api.
 */
export interface PartiesV2ApiGetPartiesV2Request {
    readonly id?: string

    readonly ids?: Array<string>

    readonly name?: string

    readonly email?: string

    readonly contactNo?: string

    readonly shortName?: string

    readonly search?: string

    readonly counterPartyType?: CounterPartyType

    readonly partyType?: PartyType

    readonly page?: number

    readonly limit?: number
}

/**
 * Request parameters for getPartyByIdV2 operation in PartiesV2Api.
 */
export interface PartiesV2ApiGetPartyByIdV2Request {
    /**
     * Party ID
     */
    readonly id: string
}

/**
 * Request parameters for updatePartyV2 operation in PartiesV2Api.
 */
export interface PartiesV2ApiUpdatePartyV2Request {
    /**
     * Party ID
     */
    readonly id: string

    /**
     * Party data to update
     */
    readonly updatePartyV2Request: UpdatePartyV2Request
}

/**
 * PartiesV2Api - object-oriented interface
 */
export class PartiesV2Api extends BaseAPI {
    /**
     * Create a new party.  `party_type` is mandatory after Phase 1 of the party unification — every party must declare its business class (`pg`, `bank`, `business`). `counter_party_type` is mandatory only for `business`; the service layer rejects mismatches.
     * @param {PartiesV2ApiCreatePartyV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPartyV2(requestParameters: PartiesV2ApiCreatePartyV2Request, options?: RawAxiosRequestConfig) {
        return PartiesV2ApiFp(this.configuration).createPartyV2(requestParameters.createPartyV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a party (set is_deleted to true)
     * @param {PartiesV2ApiDeletePartyV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePartyV2(requestParameters: PartiesV2ApiDeletePartyV2Request, options?: RawAxiosRequestConfig) {
        return PartiesV2ApiFp(this.configuration).deletePartyV2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List parties with optional filtering, search, batch lookup, and pagination.  Filter semantics relevant to the GRS unification flow:   - `ids` (repeated query param) — batch lookup. GRS uses this to enrich     a list of `entities` rows in one call instead of N+1.   - `party_type` — required for the GRS create / search flow; absent for     legacy callers.   - `counter_party_type` — multi-value array (`?counter_party_type=customer&counter_party_type=vendor`).     When `party_type=pg|bank` and no `counter_party_type` is provided, the     service applies an `IS NULL` filter (PG/Bank parties have no counter-party).
     * @param {PartiesV2ApiGetPartiesV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPartiesV2(requestParameters: PartiesV2ApiGetPartiesV2Request = {}, options?: RawAxiosRequestConfig) {
        return PartiesV2ApiFp(this.configuration).getPartiesV2(requestParameters.id, requestParameters.ids, requestParameters.name, requestParameters.email, requestParameters.contactNo, requestParameters.shortName, requestParameters.search, requestParameters.counterPartyType, requestParameters.partyType, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get party by ID
     * @param {PartiesV2ApiGetPartyByIdV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPartyByIdV2(requestParameters: PartiesV2ApiGetPartyByIdV2Request, options?: RawAxiosRequestConfig) {
        return PartiesV2ApiFp(this.configuration).getPartyByIdV2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing party
     * @param {PartiesV2ApiUpdatePartyV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePartyV2(requestParameters: PartiesV2ApiUpdatePartyV2Request, options?: RawAxiosRequestConfig) {
        return PartiesV2ApiFp(this.configuration).updatePartyV2(requestParameters.id, requestParameters.updatePartyV2Request, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PointOfContactV2Api - axios parameter creator
 */
export const PointOfContactV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new point of contact
         * @param {CreatePocV2Request} createPocV2Request Point of contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPocV2: async (createPocV2Request: CreatePocV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPocV2Request' is not null or undefined
            assertParamExists('createPocV2', 'createPocV2Request', createPocV2Request)
            const localVarPath = `/api/v2/point-of-contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPocV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Soft delete a point of contact (set is_deleted to true)
         * @param {string} id POC ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePocV2: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePocV2', 'id', id)
            const localVarPath = `/api/v2/point-of-contact/{id}/delete-poc`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a point of contact by ID
         * @param {string} id POC ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPocByIdV2: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPocByIdV2', 'id', id)
            const localVarPath = `/api/v2/point-of-contact/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all point of contacts with optional filtering, search, pagination, and sorting
         * @param {string} [id] UUID to get a specific point of contact
         * @param {string} [partyId] Optional filter by party ID
         * @param {string} [name] Optional filter by point of contact name
         * @param {string} [email] Optional filter by point of contact email
         * @param {string} [contactNo] Optional filter by point of contact contact number
         * @param {string} [search] Optional search term for name and email
         * @param {number} [page] Page number for pagination (default: 1)
         * @param {number} [limit] Number of items per page (default: 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPocV2: async (id?: string, partyId?: string, name?: string, email?: string, contactNo?: string, search?: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v2/point-of-contact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (partyId !== undefined) {
                localVarQueryParameter['party_id'] = partyId;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (contactNo !== undefined) {
                localVarQueryParameter['contact_no'] = contactNo;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an existing point of contact
         * @param {string} id POC ID
         * @param {UpdatePocV2Request} updatePocV2Request POC data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePocV2: async (id: string, updatePocV2Request: UpdatePocV2Request, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePocV2', 'id', id)
            // verify required parameter 'updatePocV2Request' is not null or undefined
            assertParamExists('updatePocV2', 'updatePocV2Request', updatePocV2Request)
            const localVarPath = `/api/v2/point-of-contact/{id}/update-poc`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePocV2Request, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PointOfContactV2Api - functional programming interface
 */
export const PointOfContactV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PointOfContactV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new point of contact
         * @param {CreatePocV2Request} createPocV2Request Point of contact data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPocV2(createPocV2Request: CreatePocV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PocV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPocV2(createPocV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointOfContactV2Api.createPocV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Soft delete a point of contact (set is_deleted to true)
         * @param {string} id POC ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePocV2(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PocV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePocV2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointOfContactV2Api.deletePocV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a point of contact by ID
         * @param {string} id POC ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPocByIdV2(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PocV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPocByIdV2(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointOfContactV2Api.getPocByIdV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all point of contacts with optional filtering, search, pagination, and sorting
         * @param {string} [id] UUID to get a specific point of contact
         * @param {string} [partyId] Optional filter by party ID
         * @param {string} [name] Optional filter by point of contact name
         * @param {string} [email] Optional filter by point of contact email
         * @param {string} [contactNo] Optional filter by point of contact contact number
         * @param {string} [search] Optional search term for name and email
         * @param {number} [page] Page number for pagination (default: 1)
         * @param {number} [limit] Number of items per page (default: 10)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPocV2(id?: string, partyId?: string, name?: string, email?: string, contactNo?: string, search?: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PocsV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPocV2(id, partyId, name, email, contactNo, search, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointOfContactV2Api.getPocV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an existing point of contact
         * @param {string} id POC ID
         * @param {UpdatePocV2Request} updatePocV2Request POC data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePocV2(id: string, updatePocV2Request: UpdatePocV2Request, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PocV2Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePocV2(id, updatePocV2Request, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PointOfContactV2Api.updatePocV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PointOfContactV2Api - factory interface
 */
export const PointOfContactV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PointOfContactV2ApiFp(configuration)
    return {
        /**
         * Create a new point of contact
         * @param {PointOfContactV2ApiCreatePocV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPocV2(requestParameters: PointOfContactV2ApiCreatePocV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PocV2Response> {
            return localVarFp.createPocV2(requestParameters.createPocV2Request, options).then((request) => request(axios, basePath));
        },
        /**
         * Soft delete a point of contact (set is_deleted to true)
         * @param {PointOfContactV2ApiDeletePocV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePocV2(requestParameters: PointOfContactV2ApiDeletePocV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PocV2Response> {
            return localVarFp.deletePocV2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a point of contact by ID
         * @param {PointOfContactV2ApiGetPocByIdV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPocByIdV2(requestParameters: PointOfContactV2ApiGetPocByIdV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PocV2Response> {
            return localVarFp.getPocByIdV2(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all point of contacts with optional filtering, search, pagination, and sorting
         * @param {PointOfContactV2ApiGetPocV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPocV2(requestParameters: PointOfContactV2ApiGetPocV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<PocsV2Response> {
            return localVarFp.getPocV2(requestParameters.id, requestParameters.partyId, requestParameters.name, requestParameters.email, requestParameters.contactNo, requestParameters.search, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an existing point of contact
         * @param {PointOfContactV2ApiUpdatePocV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePocV2(requestParameters: PointOfContactV2ApiUpdatePocV2Request, options?: RawAxiosRequestConfig): AxiosPromise<PocV2Response> {
            return localVarFp.updatePocV2(requestParameters.id, requestParameters.updatePocV2Request, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPocV2 operation in PointOfContactV2Api.
 */
export interface PointOfContactV2ApiCreatePocV2Request {
    /**
     * Point of contact data
     */
    readonly createPocV2Request: CreatePocV2Request
}

/**
 * Request parameters for deletePocV2 operation in PointOfContactV2Api.
 */
export interface PointOfContactV2ApiDeletePocV2Request {
    /**
     * POC ID
     */
    readonly id: string
}

/**
 * Request parameters for getPocByIdV2 operation in PointOfContactV2Api.
 */
export interface PointOfContactV2ApiGetPocByIdV2Request {
    /**
     * POC ID
     */
    readonly id: string
}

/**
 * Request parameters for getPocV2 operation in PointOfContactV2Api.
 */
export interface PointOfContactV2ApiGetPocV2Request {
    /**
     * UUID to get a specific point of contact
     */
    readonly id?: string

    /**
     * Optional filter by party ID
     */
    readonly partyId?: string

    /**
     * Optional filter by point of contact name
     */
    readonly name?: string

    /**
     * Optional filter by point of contact email
     */
    readonly email?: string

    /**
     * Optional filter by point of contact contact number
     */
    readonly contactNo?: string

    /**
     * Optional search term for name and email
     */
    readonly search?: string

    /**
     * Page number for pagination (default: 1)
     */
    readonly page?: number

    /**
     * Number of items per page (default: 10)
     */
    readonly limit?: number
}

/**
 * Request parameters for updatePocV2 operation in PointOfContactV2Api.
 */
export interface PointOfContactV2ApiUpdatePocV2Request {
    /**
     * POC ID
     */
    readonly id: string

    /**
     * POC data to update
     */
    readonly updatePocV2Request: UpdatePocV2Request
}

/**
 * PointOfContactV2Api - object-oriented interface
 */
export class PointOfContactV2Api extends BaseAPI {
    /**
     * Create a new point of contact
     * @param {PointOfContactV2ApiCreatePocV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPocV2(requestParameters: PointOfContactV2ApiCreatePocV2Request, options?: RawAxiosRequestConfig) {
        return PointOfContactV2ApiFp(this.configuration).createPocV2(requestParameters.createPocV2Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Soft delete a point of contact (set is_deleted to true)
     * @param {PointOfContactV2ApiDeletePocV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deletePocV2(requestParameters: PointOfContactV2ApiDeletePocV2Request, options?: RawAxiosRequestConfig) {
        return PointOfContactV2ApiFp(this.configuration).deletePocV2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a point of contact by ID
     * @param {PointOfContactV2ApiGetPocByIdV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPocByIdV2(requestParameters: PointOfContactV2ApiGetPocByIdV2Request, options?: RawAxiosRequestConfig) {
        return PointOfContactV2ApiFp(this.configuration).getPocByIdV2(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all point of contacts with optional filtering, search, pagination, and sorting
     * @param {PointOfContactV2ApiGetPocV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPocV2(requestParameters: PointOfContactV2ApiGetPocV2Request = {}, options?: RawAxiosRequestConfig) {
        return PointOfContactV2ApiFp(this.configuration).getPocV2(requestParameters.id, requestParameters.partyId, requestParameters.name, requestParameters.email, requestParameters.contactNo, requestParameters.search, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an existing point of contact
     * @param {PointOfContactV2ApiUpdatePocV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePocV2(requestParameters: PointOfContactV2ApiUpdatePocV2Request, options?: RawAxiosRequestConfig) {
        return PointOfContactV2ApiFp(this.configuration).updatePocV2(requestParameters.id, requestParameters.updatePocV2Request, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new user
         * @param {IUserRequest} iUserRequest User data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (iUserRequest: IUserRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'iUserRequest' is not null or undefined
            assertParamExists('createUser', 'iUserRequest', iUserRequest)
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(iUserRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all users with optional filters and pagination
         * @param {string} [email] Filter by email
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (email?: string, page?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current user data with new JSONB permissions system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/current-user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get current user data from request headers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserOld: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/current-user-old`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update user permissions using TypeORM get method
         * @param {string} cognitoId User\&#39;s cognito ID
         * @param {UpdateUserPermissionsRequest} updateUserPermissionsRequest Permission data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPermissions: async (cognitoId: string, updateUserPermissionsRequest: UpdateUserPermissionsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cognitoId' is not null or undefined
            assertParamExists('updateUserPermissions', 'cognitoId', cognitoId)
            // verify required parameter 'updateUserPermissionsRequest' is not null or undefined
            assertParamExists('updateUserPermissions', 'updateUserPermissionsRequest', updateUserPermissionsRequest)
            const localVarPath = `/api/v1/users/{cognito_id}/update-permissions`
                .replace(`{${"cognito_id"}}`, encodeURIComponent(String(cognitoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserPermissionsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new user
         * @param {IUserRequest} iUserRequest User data to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(iUserRequest: IUserRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(iUserRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all users with optional filters and pagination
         * @param {string} [email] Filter by email
         * @param {number} [page] Page number for pagination
         * @param {number} [limit] Number of users per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(email?: string, page?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(email, page, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current user data with new JSONB permissions system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICurrentUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get current user data from request headers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserOld(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ICurrentUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserOld(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.getCurrentUserOld']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update user permissions using TypeORM get method
         * @param {string} cognitoId User\&#39;s cognito ID
         * @param {UpdateUserPermissionsRequest} updateUserPermissionsRequest Permission data to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserPermissions(cognitoId: string, updateUserPermissionsRequest: UpdateUserPermissionsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserPermissions(cognitoId, updateUserPermissionsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.updateUserPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * Create a new user
         * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(requestParameters: UsersApiCreateUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<IUserResponse> {
            return localVarFp.createUser(requestParameters.iUserRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all users with optional filters and pagination
         * @param {UsersApiGetAllUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(requestParameters: UsersApiGetAllUsersRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<IUsersResponse> {
            return localVarFp.getAllUsers(requestParameters.email, requestParameters.page, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * Get current user data with new JSONB permissions system
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<ICurrentUserResponse> {
            return localVarFp.getCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Get current user data from request headers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserOld(options?: RawAxiosRequestConfig): AxiosPromise<ICurrentUserResponse> {
            return localVarFp.getCurrentUserOld(options).then((request) => request(axios, basePath));
        },
        /**
         * Update user permissions using TypeORM get method
         * @param {UsersApiUpdateUserPermissionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserPermissions(requestParameters: UsersApiUpdateUserPermissionsRequest, options?: RawAxiosRequestConfig): AxiosPromise<PermissionsResponse> {
            return localVarFp.updateUserPermissions(requestParameters.cognitoId, requestParameters.updateUserPermissionsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createUser operation in UsersApi.
 */
export interface UsersApiCreateUserRequest {
    /**
     * User data to create
     */
    readonly iUserRequest: IUserRequest
}

/**
 * Request parameters for getAllUsers operation in UsersApi.
 */
export interface UsersApiGetAllUsersRequest {
    /**
     * Filter by email
     */
    readonly email?: string

    /**
     * Page number for pagination
     */
    readonly page?: number

    /**
     * Number of users per page
     */
    readonly limit?: number
}

/**
 * Request parameters for updateUserPermissions operation in UsersApi.
 */
export interface UsersApiUpdateUserPermissionsRequest {
    /**
     * User\&#39;s cognito ID
     */
    readonly cognitoId: string

    /**
     * Permission data to update
     */
    readonly updateUserPermissionsRequest: UpdateUserPermissionsRequest
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * Create a new user
     * @param {UsersApiCreateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createUser(requestParameters: UsersApiCreateUserRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).createUser(requestParameters.iUserRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all users with optional filters and pagination
     * @param {UsersApiGetAllUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getAllUsers(requestParameters: UsersApiGetAllUsersRequest = {}, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getAllUsers(requestParameters.email, requestParameters.page, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current user data with new JSONB permissions system
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUser(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get current user data from request headers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentUserOld(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).getCurrentUserOld(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update user permissions using TypeORM get method
     * @param {UsersApiUpdateUserPermissionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateUserPermissions(requestParameters: UsersApiUpdateUserPermissionsRequest, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).updateUserPermissions(requestParameters.cognitoId, requestParameters.updateUserPermissionsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



